import React, { useState } from 'react';
import { cities } from 'turkey-map-react/lib/data';
import { findRegionByCity, getResponsibleManagerIds } from './regionUtils';
import styles from './RegionManagementModal.module.css';

const UNASSIGNED_LIGHT = '#e2e8f0';
const UNASSIGNED_DARK = '#475569';

const TurkeyRegionMap = ({
  regions,
  selectedRegionId,
  onCityClick,
  employeesMap,
  isDarkMode,
  getCityDetails
}) => {
  const [tooltip, setTooltip] = useState(null);

  const getManagerNames = (region, cityName) => {
    if (!region) return [];
    return getResponsibleManagerIds(region, cityName)
      .map((managerId) => employeesMap[managerId])
      .filter(Boolean);
  };

  const handleMouseMove = (event, city) => {
    const region = findRegionByCity(regions, city.name);
    const details = getCityDetails ? getCityDetails(city.name) : null;

    setTooltip({
      x: event.clientX,
      y: event.clientY,
      cityName: city.name,
      regionName: region?.name || null,
      regionColor: region?.color || null,
      managerNames: getManagerNames(region, city.name),
      details
    });
  };

  return (
    <div className={styles.mapWrapper}>
      <svg
        viewBox="12 134 1027 464"
        className={styles.mapSvg}
        role="img"
        aria-label="Türkiye bölge haritası"
      >
        {cities.map((city) => {
          const region = findRegionByCity(regions, city.name);
          const isInSelectedRegion = region && region.id === selectedRegionId;
          const fill = region
            ? region.color
            : (isDarkMode ? UNASSIGNED_DARK : UNASSIGNED_LIGHT);

          return (
            <path
              key={city.plateNumber}
              d={city.path}
              fill={fill}
              className={`${styles.cityPath} ${isInSelectedRegion ? styles.cityInSelectedRegion : ''}`}
              onClick={() => onCityClick(city)}
              onMouseMove={(event) => handleMouseMove(event, city)}
              onMouseLeave={() => setTooltip(null)}
            />
          );
        })}
      </svg>

      {tooltip && (
        <div
          className={styles.mapTooltip}
          style={{ left: tooltip.x + 14, top: tooltip.y + 14 }}
        >
          <div className={styles.tooltipCity}>{tooltip.cityName}</div>
          {tooltip.regionName ? (
            <>
              <div className={styles.tooltipRegion}>
                <span
                  className={styles.tooltipDot}
                  style={{ backgroundColor: tooltip.regionColor }}
                />
                {tooltip.regionName}
              </div>
              {tooltip.managerNames.length > 0 && (
                <div className={styles.tooltipManager}>
                  Bölge Sorumlusu: {tooltip.managerNames.join(', ')}
                </div>
              )}
            </>
          ) : (
            <div className={styles.tooltipUnassigned}>Bölge atanmamış</div>
          )}

          {tooltip.details && tooltip.details.centerCount > 0 && (
            <div className={styles.tooltipDetails}>
              <div className={styles.tooltipSummary}>
                {tooltip.details.centerCount} merkez · {tooltip.details.workerCount} çalışan · {tooltip.details.projectCount} proje
              </div>
              {tooltip.details.centers.slice(0, 4).map((center) => (
                <div key={center.id} className={styles.tooltipCenterLine}>
                  • {center.name} — {center.workerCount} çalışan, {center.projectCount} proje
                </div>
              ))}
              {tooltip.details.centers.length > 4 && (
                <div className={styles.tooltipCenterLine}>
                  + {tooltip.details.centers.length - 4} merkez daha
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TurkeyRegionMap;
